export const TYPE = {
  EMBED_TYPE_LINEAR: 'linear',
  EMBED_TYPE_VOD: 'vod',
  EMBED_TYPE_HEADLESS: 'headless',
  EMBED_TYPE_ALL: 'all',
};

export const ALLOWED_CHANNELS = [
  '58e2cd77a84e99942f414e68',
  '58e3f1fa91586c9d2fbe7579',
  '5268abcd0ce20a8472000114',
  '5812afe1d0f0b8d55dde67fa',
  '5331d5fb753499095a00045a',
  '55b179af994403942f3061d6',
  '5459795fc9f133a519bc0bef',
  '55b285cd2665de274553d66f',
  '54ff7ba69222cb1c2624c584',
  '56340779a738201b4ccfeac9',
  '59b722526996084038c01e1b',
  '5812b223e58ad7c757009420',
  '5616f9c0ada51f8004c4b091',
  '5417a212ff9fba68282fbf5e',
  '59641d9173ac1fec2fc01f17',
  '545943f1c9f133a519bbac92',
  '554158e864526b29254ff105',
  '599375885ceaac3cabccbed7',
  '5616fc1cf39f506e04b61dfc',
  '561c5d74ada51f8004c4d85d',
  '561c5f613286e48904fb2677',
  '56283c8769ba54637dea0464',
  '561c5be8ada51f8004c4d856',
  '561c5c7f3286e48904fb2586',
  '56b27a7badb45b1f50b91b0b',
  '5949b0ee44611d474e44d24e',
  '563d0989f745b5eb6bf1a11f',
  '5812bd9f249444e05d09cc4e',
  '5317bfebff98025b3200ff99',
  '5ab3e1242be690697279c75d',
  '5aea40b35126c2157123aa64',
  '5595e43c66ace1652e63c6a2',
  '5aec96ec5126c2157123c657',
  '59c2c3ae40e64939daad8b76',
  '561721d6ada51f8004c4b474',
  '589aa03df9ba56a84197a560',
  '54ee5ea872c1cbb844546d3f',
];
